import * as React from "react"

type PopupModelProps = {
  children: React.ReactNode
  className?: string
}
export const PopupModel = React.forwardRef<HTMLDivElement, PopupModelProps>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        className="h-screen overflow-y-scroll fixed grid-container inset-0 z-[90] w-full flex items-center justify-center bg-[rgba(0,0,0,0.27)]"
      >
        <div
          className={`backdrop-blur-lg my-10 rounded-xl popup-bg p-5 ${props.className}`}
        >
          {props.children}
        </div>
      </div>
    )
  }
)
